import React, { useState } from 'react';
import { CheckAndFinanceForm } from '../../../../../../components';
import { modalNotification } from '../../../../../../utils';
import { financingPaymentService } from '../../../../../../services/index.service';
import { purchaseMemberShipPlan } from '../../../../../../services/Customers/customers.service';

export default function FinancingComponent({
  defaultKey,
  rowData,
  setIsOpenModal,
  getData,
  authorizedUser,
  paymentDetails,
  memberShip,
  isAlreadyActivate,
}) {
  const [loading, setLoading] = useState(false);

  const onSubmit = async (value) => {
    setLoading(true);
    try {
      let bodyData = {
        bookingId: rowData?.BookingDetail?.bookingId,
        paidAmount: value?.amountToPay,
        bankName: value?.bankName,
        financingNumber: value?.finance,
        reason: paymentDetails?.reason,
      };
      let memberShipBodyData = {
        ...(isAlreadyActivate ? { isUpgradePlan: 1 } : ''),
        customerId: rowData?.customerId,
        membershipPlanId: rowData?.memberShipPlanId,
        durationType: rowData?.planType,
        bankName: value?.bankName,
        financingNumber: value?.finance,
        paymentMethod: 'financing',
      };
      const response = memberShip
        ? await purchaseMemberShipPlan({ memberShipBodyData })
        : await financingPaymentService({ bodyData });

      if (response?.success) {
        modalNotification({
          type: 'success',
          message: response?.message,
        });
        setIsOpenModal(false);
        getData();
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  return (
    <CheckAndFinanceForm
      onSubmit={onSubmit}
      defaultKey={defaultKey}
      rowData={rowData}
      loading={loading}
      authorizedUser={authorizedUser}
      paymentDetails={paymentDetails}
    />
  );
}
